import { date, type Language, type MonthYear } from '@seek/ca-myprofile-utils';

export const formatRoleDate = async (
  { from, to }: { from: MonthYear; to?: MonthYear },
  language: Language = 'en',
) => {
  const roleLength = await date.getTimeSpan(from, to, language);
  return `(${roleLength})`;
};

export const constructFromAndToDates = (mostRecentTenureMonths: number) => {
  const dateInThePast = new Date();
  dateInThePast.setMonth(dateInThePast.getMonth() - mostRecentTenureMonths);
  const now = new Date();
  return {
    from: {
      month: dateInThePast.getMonth() + 1,
      year: dateInThePast.getFullYear(),
    },
    to: {
      month: now.getMonth() + 1,
      year: now.getFullYear(),
    },
  };
};
